import React, { Component } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Link } from 'react-router-dom';
import auth from '../../service/authService';
import $ from 'jquery';


class LoginChangeUser extends Component {

	componentDidMount(){
		if(auth.getJwt()){
		   return this.props.history.push('/dashBoardLocations');
		}
		else{
			document.body.style.backgroundColor = "#0d3968";
			$("body").addClass("loginBg");
		}
	}

	render() {
		return (
            <React.Fragment>
				<div class="loginBg">
                    <div id="adminWrapper">
        {/* <!-- Loading Progress --> */}
        <div class="loadingProgress">
            <div class="loadingProgressIn"></div>
        </div>
        {/* <!-- //Loading Progress --> 
		
		<!-- Fixed Header navbar --> */}
        <nav class="navbar navbar-expand-lg navbar-dark bgAdmin">  
                <Link class="navbar-brand welbiltLogo" title="Welbilt - Bringing innovation to the table" to="#">&nbsp;</Link>
         
        </nav>
        {/* <!-- //Fixed Header navbar -->
		
        <!-- //Fixed Header navbar --> */}
        <div id="page-wrapper"> 
		<div className="welcomText">Welcome</div>
			{/* <!-- Login Form --> */}
			<div class="LoginBtnWrapper"> 
				
				<div id="loginBtnFormID">
				<div class="loginButton">
					<ul>
						<li>&nbsp;</li>
						<li>
							<div class="loginIWrapper">
							<div class="existingLoginForm">  
								<ul>
									<li class="form-group">
										<div class="input-group">  
											<input type="text" name="Email" class="form-control" placeholder="Enter your Email"/>  
										</div>
									</li>
									<li class="form-group pass"> 
										<div class="input-group">
											<input class="form-control pwd" name="PasswordHash" placeholder="Enter Password" type="password" value="" />
											<span class="input-group-btn">
												<button class="btn input-group-addon reveal" type="button"><i class="glyphicon glyphicon-eye-open"></i></button>
											</span>
										</div>   
									</li>
									<li class="form-group pass"> 
										  <div class="customCheckbox customCheckboxWlabel">
                                            <input id="RememberMe" checked="checked" name="RememberMe" type="checkbox" value="RememberMe"/>
                                            <label for="RememberMe">Remember Me</label>
                                        </div>
										{/* <Link to="loginfail.html" title="Language" class="ForgotPassword">Forgot Password</Link> */}
                                        <Link to="/forgetPassword" title="Language" class="ForgotPassword">Forgot Password</Link>
									</li> 
									<li class="form-group pass"> 
										<button class="btn btn-secondary existingSingINBtn" type="button" id="existingSignInButton">Sign In</button>
									</li> 
								</ul>
							</div>
							</div>
						</li>
						<li>&nbsp;</li>
					</ul>
					<ul>
						<li><Link to="#" title="Create Account">Create Account</Link></li>
						<li>
							<div class="loginIWrapper">
							<Link to="#" title="Forgot Email" class="useExistingAccount">Forgot Email</Link> 
                            <Link to="/" title="Language" class="languageSel"></Link>
							</div>
						</li> 
						<li>&nbsp;</li>
					</ul>
				</div>
				</div> 
			</div> 
			
			{/* <!-- //Login Form -->   */}
        </div>
    </div> 
	
	
	
	{/* <!-- SignIn Modal --> */}
    <div class="modal fade" data-keyboard="false" data-backdrop="static" id="SignInModal" tabindex="-1" role="dialog" aria-labelledby="SignInModalLabel">
        <div class="modal-dialog modal-md loginModal">
            <div class="modal-content"> 
                <div class="modal-body">
                   
				
					
						 
				 
                </div>
                <div class="modal-footer textAlignCenter">
                   <button class="btn btn-secondary singINBtn" type="button" id="SignInButton">Sign In</button>
                </div>
            </div>
        </div>
    </div>
    {/* <!-- //SignIn Modal -->
	<!-- SignIn Confirmation Modal --> */}
    <div class="modal fade" data-keyboard="false" data-backdrop="static" id="SignInSuccessModal" tabindex="-1" role="dialog" aria-labelledby="SignInSuccessModalLabel">
        <div class="modal-dialog modal-md loginModal">
            <div class="modal-content"> 
                <div class="modal-body"> 
					<div class="singINConfirmation"> 
					You successfully created your personal password!
					</div>
						 
				 
                </div>
                <div class="modal-footer textAlignCenter">
                   <button class="btn btn-secondary signINconfirmationOKBtn" type="button">OK</button>
                </div>
            </div>
        </div>
    </div>
            </div>
			</React.Fragment>
		)
	}
};

export default LoginChangeUser;